import { axiosInstance } from "../../../api/axiosInstance.tsx";

export interface ItemSearchParams {
  keyword?: string;
  code?: string;
  name?: string;
  description?: string;
  category?: string;
  limit?: number;
  offset?: number;
  orderBy?: string;
  order?: string;
}

export const getItems = async (params: ItemSearchParams = {}) => {
  const response = await axiosInstance.get("/items/search_items", {
    params,
  });
  return response.data;
};


export const fetchItemPhotoBlob = async (filename: string): Promise<string | null> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(`/items/photo/${filename}`, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const objectUrl = URL.createObjectURL(response.data);
    return objectUrl;
  } catch (error) {
    console.error("Gagal mengambil foto:", error);
    return null;
  }
};



// Step 1: Create Item
export const createItemCategory = async (data) => {
  const formData = {
    name: data.itemGroupName,
    description: data.itemDescription,
    category: data.selectedItem,
  };

  const response = await axiosInstance.post(`/items/create_item`, formData);
  return response.data; // contains the item `id` or `code`
};

// Step 2: Upload Photo by Item ID
export const uploadItemPhoto = async (itemId, file) => {
  const formData = new FormData();
  formData.append("photo", file);

  return axiosInstance.post(`/items/upload_photo/${itemId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


// Edit Item
export const editItemCategory = async (data) => {
  const formData = {
    name: data.itemGroupName,
    description: data.itemDescription,
    category: data.selectedItem,
  };

  const response = await axiosInstance.put(`/items/update_item/${data.id}`, formData);
  return response.data; // contains the item `id` or `code`
};

export const deleteItem = async (itemId: string) => {
  const response = await axiosInstance.delete(`/items/delete_item/${itemId}`);
  return response.data;
};
